import { Node, mergeAttributes } from '@tiptap/core';

const Video = Node.create({
  name: 'video',

  group: 'block',
  selectable: true,
  atom: false,
  draggable: true,

  addAttributes() {
    return {
      src: { default: null },
      controls: { default: true },
      style: { default: 'border-radius: 8px; margin-top: 10px;' },
      width: { default: '100%' },
      type: { default: 'video/mp4' },
      'data-video-id': { default: null },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'video',
        getAttrs: (el) => {
          const src =
            el.querySelector('source')?.getAttribute('src') ||
            el.getAttribute('src');
          return {
            src,
            controls: el.hasAttribute('controls'),
            style: el.getAttribute('style'),
            width: el.getAttribute('width'),
            type:
              el.querySelector('source')?.getAttribute('type') || 'video/mp4',
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const { src, type } = HTMLAttributes;
    return [
      'video',
      mergeAttributes(HTMLAttributes, { controls: true }),
      [
        'source',
        {
          src,
          type: type || 'video/mp4',
        },
      ],
      'Tu navegador no soporta video.',
    ];
  },
});

export default Video;
